import retina from 'src/vendors/retina/retina';

export function init_retina(){
    
    if( typeof retina === 'undefined' ) return;
    if( window.devicePixelRatio < 2) return;

    const items = document.querySelectorAll('.retina');
    if( !items ) return;
    
    items.forEach(item=>{
        if( item.nodeName == 'IMG' ) {
            item.dataset.rjs = 2;
        } else {
            // add to children
            item.querySelectorAll('img').forEach(img=>{
                if( img.src.includes('.svg') ) return;
                img.dataset.rjs = 2;
            })
        }
    })
    
    retina();
}